export default __webpack_public_path__ + "static/media/N2P_1901.6c32f34a.jpg";